import React from "react";
import { Col, Container, ListGroup, Row } from "react-bootstrap";
import { getFieldsList } from "../../lib/api";
import { useLoaderData } from "react-router";
import { IAPIResponse, IField } from "../../types/api";

import "../../assets/css/wibb/pages/fields.scss";
import { Link } from "react-router-dom";

export const loader = async () => {
    return getFieldsList();
};

const Fields = (): React.JSX.Element => {
    const { fields: fieldList } = useLoaderData() as IAPIResponse & {
        fields: IField[];
    };

    const fieldLetters = new Set<string>();
    fieldList
        .filter(f => f.active === 1)
        .forEach(i => {
            const firstChar = i.name.charAt(0).toUpperCase();
            fieldLetters.add(isNaN(parseInt(firstChar)) ? firstChar : "#");
        });

    const sortedLetters = Array.from(fieldLetters).sort();

    return (
        <div data-testid="fieldsContent">
            <Container className="py-5 fields">
                <Row>
                    <Col>
                        <ListGroup
                            horizontal
                            as="ul"
                            id="letterList"
                            className="list-group-links"
                        >
                            {sortedLetters.map(l => (
                                <ListGroup.Item key={l} as="li">
                                    <a href={`#${l}`}>{l}</a>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>

                        {sortedLetters.map(letter => (
                            <div
                                key={letter}
                                id={letter}
                                className="fieldSection"
                            >
                                <h2 className="border-bottom-dark">{letter}</h2>
                                <ul>
                                    {fieldList
                                        .filter(f => f.active === 1)
                                        .filter(({ name }) => {
                                            const firstChar = name
                                                .charAt(0)
                                                .toUpperCase();

                                            if (letter === "#") {
                                                return !isNaN(
                                                    parseInt(firstChar),
                                                );
                                            } else {
                                                return letter === firstChar;
                                            }
                                        })
                                        .sort((a, b) =>
                                            a.name.localeCompare(b.name),
                                        )
                                        .map(({ id, name }) => (
                                            <li key={id}>
                                                <Link
                                                    to={`/fields/${id}`}
                                                    target="_blank"
                                                >
                                                    {name}
                                                </Link>
                                            </li>
                                        ))}
                                </ul>
                                <p>
                                    <a
                                        href="#"
                                        onClick={() => {
                                            window.scrollTo({
                                                top: 0,
                                                behavior: "instant",
                                            });
                                            return false;
                                        }}
                                    >
                                        ^ Back to Top ^
                                    </a>
                                </p>
                            </div>
                        ))}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Fields;
